import React, { useEffect, useState } from 'react'
import { Button, Form, Select, Spin, Modal, ConfigProvider } from 'antd'
import { addTrack, fetchTrackNetworksOptions, fetchTrackAdvertisersOptions, fetchTrackBrands } from '../../apis/group'
import { FormButton } from './group.styled'
import { useTranslation } from 'react-i18next'

const TrackForm = props => {
  const [form] = Form.useForm()
  const { t: ln_t } = useTranslation()

  const { formMode, setFormMode, handleFetchParams, groupRecord } = props

  const [modalLoading, setModalLoading] = useState(false)
  const [networkTrackList, setNetWorkTrackList] = useState([])
  const [advertiseTrackList, setAdvertiseTrackList] = useState([])
  const [brandList, setBrandList] = useState([])
  const [selectedItem, setSelectedItem] = useState({})

  const getTrackNetworkList = async () => {
    setModalLoading(true)

    const result = await fetchTrackNetworksOptions({ maxResults: 1000 })
    if (result.status === 200) {
      const siteOptions = result.data.map(data => ({ label: data.name, value: data.id }))
      setNetWorkTrackList(siteOptions)
      // return siteOptions
    }
    setModalLoading(false)
  }

  const getTrackAdvertiseList = async () => {
    setModalLoading(true)

    const result = await fetchTrackAdvertisersOptions({ maxResults: 1000 })
    if (result.status === 200) {
      const siteOptions = result.data.map(data => ({ label: data.name_cn, value: data.id }))
      setAdvertiseTrackList(siteOptions)
      // return siteOptions
    }
    setModalLoading(false)
  }

  const handleCancel = () => {
    form.resetFields()
    setFormMode(false)
  }

  const onFinish = async fieldsValue => {
    const f = fieldsValue
    setModalLoading(true)

    const values = {
      trackBrandId: f.id,
      name: selectedItem.label,
      groupId: groupRecord.id,
      status: 1
    }

    const result = await addTrack(values)
    if (result?.status === 201) {
      handleFetchParams('add', {})
      handleCancel()
    }
    setModalLoading(false)
  }

  const onBrandChange = value => {
    const n = brandList.find(item => item.value === value)
    setSelectedItem(n)
  }

  const getTrackBrands = async (network, advertiser) => {
    const result = await fetchTrackBrands(network, advertiser)
    if (result?.status === 200) {
      const brandOpts = result.data.map(item => ({ label: item.name, value: item.id }))
      setBrandList(brandOpts)
    }
  }

  const handleOptionChange = async () => {
    const { network, advertiser } = form.getFieldsValue()
    if (network && advertiser) await getTrackBrands(network, advertiser)
    form.setFieldsValue({ id: undefined })
  }

  useEffect(() => {
    // console.log(formMode, siteList.length)
    if (formMode) getTrackNetworkList(); getTrackAdvertiseList()
  }, [formMode])

  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
      <Modal
        width="470px"
        title={ln_t('track.addNew')}
        open={formMode}
        footer={null}
        onCancel={handleCancel}
      >
      <Spin spinning={modalLoading}>
        <div className="main-form-container" style={{ marginTop: '15px' }}>
          <Form
            form={form}
            onFinish={onFinish}
            requiredMark={false}
            validateTrigger="onSubmit"
            layout="vertical"
          >
        <Form.Item label={ln_t('track.selectTrackNetwork')} name="network" rules={[{ required: true, message: ln_t('track.pleaseSelectTrackNetwork') }]}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={ln_t('track.pleaseSelectTrackNetwork')}
            options={networkTrackList}
            onChange={handleOptionChange}
          />
        </Form.Item>
        <Form.Item label={ln_t('track.selectTrackAdviser')} name="advertiser" rules={[{ required: true, message: ln_t('track.pleaseSelectTrackAdviser') }]}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={ln_t('track.pleaseSelectTrackAdviser')}
            options={advertiseTrackList}
            onChange={handleOptionChange}
          />
        </Form.Item>
          <Form.Item label={ln_t('track.selectTrackBrand')} name="id" rules={[{ required: true, message: ln_t('track.pleaseSelectTrackBrand') }]}>
            <Select
              showSearch
              optionFilterProp="label"
              placeholder={ln_t('track.selectTrackFirst')}
              options={brandList}
              onChange={onBrandChange}
            />
        </Form.Item>
          <FormButton>
              <Button type="button" onClick={handleCancel} className="mr-2">{ln_t('util.cancel')}</Button>
              <Button type="primary" htmlType="submit">{ln_t('util.confirm')}</Button>
          </FormButton>
        </Form>
        </div>
      </Spin>
      </Modal>
  </ConfigProvider>
  )
}

export default TrackForm
